import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

interface SectionHeaderProps {
  title: string;
  className?: string;
  onBack?: () => void;
}

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: "32px",
    lineHeight: "40px",
    letterSpacing: "-0.9px",
    verticalAlign: "middle",
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "25px",
    },
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.14)",
    border: "none",
    cursor: "pointer",
    flexShrink: 0,
    padding: 0,
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.18)",
    },
  },
}));

const SectionHeader = ({ title, className, onBack }: SectionHeaderProps) => {
  const classes = useStyles();

  return (
    <div className={`${classes.row}${className ? ` ${className}` : ""}`}>
      {onBack && (
        <button type="button" className={classes.backButton} onClick={onBack} aria-label="Volver">
          <ArrowBackIcon style={{ fontSize: 14 }} />
        </button>
      )}
      <Typography className={classes.root} component="h1">
        {title}
      </Typography>
    </div>
  );
};

export default SectionHeader;
